import React, { useState, useEffect, useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import 'bootstrap/dist/css/bootstrap.min.css';
import { buildServerUrl } from '../utils/serverUrl';
import backboardOfPlatform from '../assets/stacker assets/Backboard of Platform/Back board and connection rods.png'
import Posts from '../assets/stacker assets/Post/Primary post with left carriage and right carriedge.png'
import PostSupport from '../assets/stacker assets/Front Support/Front Support.png'
import BalanceChain1 from '../assets/stacker assets/Balance Chain/Balance Chain Fixture on base of primary post.png'
import BalanceChain2 from '../assets/stacker assets/Balance Chain/Screenshot 2025-07-17 at 3.34.20.png'
import BalanceChain3 from '../assets/stacker assets/Balance Chain/Screenshot 2025-07-17 at 3.33.42.png'
import LiftingChain1 from '../assets/stacker assets/Lifting Chain/Lifting Chain.png'
import LiftingChain2 from '../assets/stacker assets/Lifting Chain/Screenshot 2025-07-17 at 2.19.33.png'
import Cylinder1 from '../assets/stacker assets/Cylinder/Cylinder1.png'
import Cylinder2 from '../assets/stacker assets/Cylinder/Cylinder2.png'
import Cylinder3 from '../assets/stacker assets/Cylinder/Cylinder3.png'
import HydraulicHoses1 from '../assets/stacker assets/Hydraulic Hoses/Screenshot 2025-07-17 at 2.19.44 PM.png'
import HydraulicHoses2 from '../assets/stacker assets/Hydraulic Hoses/Top & Base of primary post.png'
import PowerPack1 from '../assets/stacker assets/Power Pack/Screenshot 2025-07-17 at 2.19.58 PM.png'
import PowerPack2 from '../assets/stacker assets/Power Pack/Screenshot 2025-07-17 at 3.44.28 PM.png'
import PowerPack3 from '../assets/stacker assets/Power Pack/Screenshot 2025-07-17 at 2.20.14 PM.png'
import ControlArm1 from '../assets/stacker assets/Control Arm/Screenshot 2025-07-17 at 2.21.27 PM.png'
import ControlArm2 from '../assets/stacker assets/Control Arm/Screenshot 2025-07-17 at 2.20.56 PM.png'
import ControlArm3 from '../assets/stacker assets/Control Arm/Screenshot 2025-07-17 at 2.21.17 PM.png'
import TopCoverPlate from '../assets/stacker assets/Top cover plate of post/Top Cover Plate on post.png'
import LNRSideBeam1 from '../assets/stacker assets/Side Beam/Lest&RightSideBeam.png'
import LNRSideBeam2 from '../assets/stacker assets/Side Beam/Bolts Directions.png'
import LNRCightCarriage from '../assets/stacker assets/Post Carriges/Primary post with left carriage and right carriedge.png'
import Ramp from '../assets/stacker assets/Ramp/Ramp.png'
import WavingPlates from '../assets/stacker assets/Waving Plates/Waving plates.png'
import ChainMounts from '../assets/stacker assets/Chain mount/Balance Chain & Chain Wheel .png'
import ControlBox1 from '../assets/stacker assets/Control Box/Screenshot 2025-07-17 at 2.21.42 PM.png'
import ControlBox2 from '../assets/stacker assets/Control Box/Screenshot 2025-07-17 at 3.41.21 PM.png'
import Electromagnet1 from '../assets/stacker assets/Electromagnet for locks/Screenshot 2025-07-17 at 2.54.29 PM.png'
import Electromagnet2 from '../assets/stacker assets/Electromagnet for locks/Screenshot 2025-07-17 at 3.42.15 PM.png'
import LimitSwitch from '../assets/stacker assets/Limit Switch/Standard position of limit switch on top cover plate.png'
import Photocell1 from '../assets/stacker assets/Photocell/Position of Photocell sensor.png'
import Photocell2 from '../assets/stacker assets/Photocell/Wire holes of photocell sensor.png'
import WiringInstalled from '../assets/stacker assets/Wiring & Cables instaled/Wire holes of primary posts.png'
import WiringTerminated1 from '../assets/stacker assets/Wires terminated/Screenshot 2025-07-17 at 3.45.09 PM.png'
import WiringTerminated2 from '../assets/stacker assets/Wires terminated/Screenshot 2025-07-17 at 3.45.21 PM.png'
import Key_Switch from '../assets/stacker assets/Key Switch/KeySwitch.png'
import MainImage from '../assets/stacker assets/Main images/General Layout.png'

// Number of checkboxes per field
const legacyCheckboxCounts = {
    'Layout & Prep Work': 1,
    'Posts': 2,
    'Post Supports (Front & Rear)': 2,
    'Top Cover Plate of Post': 1,
    'Posts Leveled': 1,
    'Left & Right Side Beam': 1,
    'Left & Right Carriage': 1,
    'Backboard of Platform': 1,
    'Connection Rods': 3,
    'Ramp of Platform': 1,
    'Waving Plates (Decking)': 1,
    'Chain Mounts': 2,
    'Balance Chain': 1,
    'Lifting Chain': 1,
    'Cylinder': 1,
    'Hydraulic Hoses': 2,
    'Power Pack (Mounted)': 1,
    'Power Pack (Wiring)': 1,
    'Control Arm': 1,
    'Control Box Bracket': 1,
    'Control Box': 1,
    'Electromagnet for Locks': 1,
    'Key Switch': 1,
    'Limit Switch': 2,
    'Photocell Sensor (Optical Sensor)': 1,
    'Wiring & Cables (Installed)': 1,
    'Wiring & Cables (Terminated)': 1,
    'Hydraulic Oil (L-HV 46#)': 1,
    'Final Electrical Connections': 1,
    'Testing & Commissioning': 1,
    'Crossbeams': 2
};

// Map each field to an array of images
const fieldImages = {
    'Layout & Prep Work': [],
    'Backboard of Platform': [backboardOfPlatform],
    'Connection Rods': [''],
    'Posts': [Posts],
    'Post Supports (Front & Rear)': [PostSupport],
    'Top Cover Plate of Post': [TopCoverPlate],
    'Posts Leveled': [''],
    'Left & Right Side Beam': [LNRSideBeam1, LNRSideBeam2],
    'Left & Right Carriage': [LNRCightCarriage],
    'Ramp of Platform': [Ramp],
    'Waving Plates (Decking)': [WavingPlates],
    'Chain Mounts': [ChainMounts],
    'Balance Chain': [BalanceChain1, BalanceChain2, BalanceChain3],
    'Lifting Chain': [LiftingChain1, LiftingChain2],
    'Cylinder': [Cylinder1, Cylinder2, Cylinder3],
    'Hydraulic Hoses': [HydraulicHoses1, HydraulicHoses2],
    'Power Pack (Mounted)':[PowerPack1, PowerPack2, PowerPack3],
    'Power Pack (Wiring)': [PowerPack1, PowerPack2, PowerPack3],
    'Control Arm': [ControlArm1, ControlArm2, ControlArm3],
    'Control Box Bracket': [ControlBox1, ControlBox2],
    'Control Box': [ControlBox1, ControlBox2],
    'Electromagnet for Locks': [Electromagnet1,Electromagnet2],
    'Key Switch': [Key_Switch],
    'Limit Switch': [LimitSwitch],
    'Photocell Sensor (Optical Sensor)': [Photocell1, Photocell2],
    'Wiring & Cables (Installed)': [WiringInstalled],
    'Wiring & Cables (Terminated)': [WiringTerminated1, WiringTerminated2],
    'Hydraulic Oil (L-HV 46#)': [],
    'Final Electrical Connections': [],
    'Testing & Commissioning': []
    // add more mappings as needed
};

const projectOptions = [
    '2440 Fulton Street', '1057 Atlantic Avenue', '33 Westchester Place',
    '261 & 315 Grand Concourse', '134 Jane Street', '362 Avenue U (2102 East 1st)',
    '29-24 40th Avenue', '625 Fulton Street', '37-16 Union Street', '67 Taaffe Place'
];
const stackerTypes = ['APS 2PK6.0', 'APS 2PK7.0', 'APS FS2000'];
let defaultUnits = ['Unit 1', 'Unit 2', 'Unit 3'];

export default function ProgressForm() {
    const [previewBigOpen, setPreviewBigOpen] = useState(false);
    const [bigZoom, setBigZoom] = useState(1);

    const handleWheelBig = e => {
        e.preventDefault();
        const delta = e.deltaY < 0 ? 0.1 : -0.1;
        setBigZoom(z => Math.min(Math.max(z + delta, 0.5), 5));
    };

    const [isV2Project, setIsV2Project] = useState(false);
    const [unitTypeAssignments, setUnitTypeAssignments] = useState({});
    const [typeSchemas, setTypeSchemas] = useState({});

    const getSchemaForUnit = (unitName) => {
        const assignment = unitTypeAssignments?.[unitName];
        const typeId = assignment?.typeId;
        if (!typeId) return null;
        return typeSchemas?.[String(typeId)] || null;
    };

    const getCheckboxCountsForUnit = (unitName) => {
        const schema = getSchemaForUnit(unitName);
        if (schema && Array.isArray(schema.steps) && schema.steps.length) {
            return schema.steps.reduce((acc, step) => {
                const qty = Math.max(0, Math.round(Number(step.quantityPerUnit || 0)));
                acc[step.stepName] = qty;
                return acc;
            }, {});
        }
        return legacyCheckboxCounts;
    };

    // Global fields
    const [project, setProject] = useState('');
    const [projects, setProjects] = useState(projectOptions);
    const [stackerType, setStackerType] = useState('');
    const [date, setDate] = useState('');
    const [manpower, setManpower] = useState('');
    const [manpowerHours, setManpowerHours] = useState('');
    const [summary, setSummary] = useState('');
    
    // New fields for management
    const [notesAndIssues, setNotesAndIssues] = useState('');
    const [reportSenderName, setReportSenderName] = useState('');
    const [numberOfEmployees, setNumberOfEmployees] = useState('');

    // Per-unit form memory
    const [currentUnit, setCurrentUnit] = useState('');
    const [unitData, setUnitData] = useState({});
    const [unitsList, setUnitsList] = useState(defaultUnits);
    const [modifiedUnits, setModifiedUnits] = useState({}); // { 'Unit 1': true }
    const buildInitialUnitForm = (unitName = '') => {
        const unitCheckboxCounts = getCheckboxCountsForUnit(unitName);
        return {
        notes: '',
        checkboxes: Object.keys(unitCheckboxCounts).reduce((acc, f) => ({ ...acc, [f]: Array(unitCheckboxCounts[f]).fill(false) }), {}),
        sitePhotos: [],
        existingPhotoUrls: [],
        signatureDataURL: '',
        fieldValues: {}
    };
    };
    const [unitForm, setUnitForm] = useState(buildInitialUnitForm());
    const [lockedUnitData, setLockedUnitData] = useState({});
    const quantityFields = Object.keys(unitForm.checkboxes || {});
    const currentUnitSchema = currentUnit ? getSchemaForUnit(currentUnit) : null;

    const [selectedPhotos, setSelectedPhotos] = useState([]);
    const [result, setResult]               = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoadingProject, setIsLoadingProject] = useState(false);

    // Photo previews
    const [previews, setPreviews] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);

    // Field slideshow
    const [fieldSlides, setFieldSlides] = useState([]);
    const [fieldSlideIndex, setFieldSlideIndex] = useState(0);

    const sigRef = useRef(null);
    const sigPadRef = useRef(null);
    const fileInputRef = useRef(null);

    // Helper to recompute previews from a unit form
    const recomputePreviewsFrom = (form) => {
        const fileUrls = form.sitePhotos.map(f => URL.createObjectURL(f));
        setPreviews([...(form.existingPhotoUrls || []), ...fileUrls]);
    };

    const normalizeUnitFormBySchema = (form, unitName) => {
        const counts = getCheckboxCountsForUnit(unitName);
        const baseCheckboxes = Object.keys(counts).reduce((acc, field) => {
            const len = counts[field];
            const fromExisting = Array.isArray(form?.checkboxes?.[field]) ? form.checkboxes[field] : [];
            acc[field] = Array.from({ length: len }, (_, idx) => Boolean(fromExisting[idx]));
            return acc;
        }, {});
        return {
            notes: form?.notes || '',
            checkboxes: baseCheckboxes,
            sitePhotos: Array.isArray(form?.sitePhotos) ? form.sitePhotos : [],
            existingPhotoUrls: Array.isArray(form?.existingPhotoUrls) ? form.existingPhotoUrls : [],
            signatureDataURL: form?.signatureDataURL || '',
            fieldValues: form?.fieldValues && typeof form.fieldValues === 'object' ? form.fieldValues : {}
        };
    };

    // Fetch available projects from server (if any)
    useEffect(() => {
        (async () => {
            try {
                const res = await fetch(buildServerUrl('/webhook/projects'));
                if (res.ok) {
                    const json = await res.json();
                    if (Array.isArray(json.projects) && json.projects.length) {
                        setProjects(json.projects);
                    }
                }
            } catch (e) {
                // ignore; fall back to static list
            }
        })();
    }, []);

    // Load project latest data when project changes
    useEffect(() => {
        (async () => {
            if (!project) {
                // Reset form when project is cleared
                setStackerType('');
                setDate('');
                setManpower('');
                setManpowerHours('');
                setSummary('');
                setNotesAndIssues('');
                setReportSenderName('');
                setNumberOfEmployees('');
                setUnitData({});
                setUnitForm(buildInitialUnitForm());
                setPreviews([]);
                setCurrentUnit('');
                setUnitsList(defaultUnits);
                setLockedUnitData({});
                setModifiedUnits({});
                setIsV2Project(false);
                setUnitTypeAssignments({});
                setTypeSchemas({});
                setIsLoadingProject(false);
                if (sigPadRef.current) sigPadRef.current.clear();
                return;
            }
            
            setIsLoadingProject(true);
            try {
                
                const res = await fetch(buildServerUrl(`/webhook/${encodeURIComponent(project)}`));
                if (!res.ok) {
                    setIsLoadingProject(false);
                    return;
                }
                const json = await res.json();
                if (!json || !json.exists) {
                    setIsLoadingProject(false);
                    return;
                }

                setIsV2Project(!!json.v2Enabled);
                setUnitTypeAssignments(json.unitTypeAssignments || {});
                setTypeSchemas(json.typeSchemas || {});
                setStackerType(json.stackerType || '');
                // Do not prefill date/manpower/summary from DB for per-stacker loads
                setDate('');
                setManpower('');
                setManpowerHours('');
                setSummary('');
                
                // Reset new management fields
                setNotesAndIssues('');
                setReportSenderName('');
                setNumberOfEmployees('');

                const incomingUnits = json.units || {};
                // For per-unit-type (v2) projects the server's unit list comes from the
                // stacker setup; use those names instead of counting to totalUnits so the
                // form never offers a unit that has no stacker type.
                const unitNum = (name) => parseInt((String(name).match(/(\d+)/) || [])[1] || '0', 10);
                const unitNamesFromServer = Object.keys(incomingUnits).sort((a, b) => unitNum(a) - unitNum(b));
                const resolvedUnitsList = (json.v2Enabled && unitNamesFromServer.length)
                    ? unitNamesFromServer
                    : (typeof json.totalUnits === 'number' && json.totalUnits > 0
                        ? Array.from({ length: json.totalUnits }, (_, i) => `Unit ${i+1}`)
                        : defaultUnits);
                const assignmentMapFromJson = json.unitTypeAssignments || {};
                const schemaMapFromJson = json.typeSchemas || {};
                const getCountsForUnitFromJson = (unitName) => {
                    const assignment = assignmentMapFromJson?.[unitName];
                    const typeId = assignment?.typeId;
                    if (typeId) {
                        const schema = schemaMapFromJson[String(typeId)];
                        if (schema && Array.isArray(schema.steps) && schema.steps.length) {
                            return schema.steps.reduce((acc, step) => {
                                acc[step.stepName] = Math.max(0, Math.round(Number(step.quantityPerUnit || 0)));
                                return acc;
                            }, {});
                        }
                    }
                    return legacyCheckboxCounts;
                };
                setUnitsList(resolvedUnitsList);
                const nextUnitData = {};
                const nextLocked = {};
                for (let unitName of resolvedUnitsList) {
                    const u = incomingUnits[unitName];
                    const unitCheckboxCounts = getCountsForUnitFromJson(unitName);
                    const unitFields = Object.keys(unitCheckboxCounts);
                    const baseCheckboxes = unitFields.reduce((acc, f) => {
                        acc[f] = Array(unitCheckboxCounts[f]).fill(false);
                        return acc;
                    }, {});
                    
                    if (u && u.checkboxes) {
                        // Normalize Waving Plates to single
                        const waving = u.checkboxes['Waving Plates (Decking)'] || [];
                        const fromDb = { ...(u.checkboxes || {}) };
                        if (Array.isArray(waving)) fromDb['Waving Plates (Decking)'] = [Boolean(waving[0])];
                        
                        // Overlay DB-provided arrays onto base
                        for (const [k, arr] of Object.entries(fromDb)) {
                            if (!baseCheckboxes[k]) continue;
                            const target = baseCheckboxes[k];
                            for (let i = 0; i < Math.min(target.length, arr.length); i++) {
                                target[i] = Boolean(arr[i]);
                            }
                        }
                        
                        nextUnitData[unitName] = {
                            notes: u.notes || '',
                            checkboxes: baseCheckboxes,
                            sitePhotos: [],
                            existingPhotoUrls: Array.isArray(u.photoUrls) ? u.photoUrls : [],
                            signatureDataURL: '',
                            fieldValues: (u.fieldValues && typeof u.fieldValues === 'object') ? u.fieldValues : {}
                        };
                        
                        
                        // Locked map mirrors base with DB truthy values
                        const locked = unitFields.reduce((acc, f) => {
                            acc[f] = (u.checkboxes && Array.isArray(u.checkboxes[f]))
                                ? u.checkboxes[f].slice(0, baseCheckboxes[f].length).map(Boolean)
                                : Array(baseCheckboxes[f].length).fill(false);
                            return acc;
                        }, {});
                        // enforce single Waving Plate
                        if (locked['Waving Plates (Decking)'] && locked['Waving Plates (Decking)'].length > 1) {
                            locked['Waving Plates (Decking)'] = [Boolean(locked['Waving Plates (Decking)'][0])];
                        }
                        nextLocked[unitName] = locked;
                    } else {
                        nextUnitData[unitName] = normalizeUnitFormBySchema({ checkboxes: baseCheckboxes }, unitName);
                    }
                }
                setUnitData(nextUnitData);
                setLockedUnitData(nextLocked);
                setCurrentUnit(prev => prev || (resolvedUnitsList[0] || 'Unit 1'));
                if (sigPadRef.current) sigPadRef.current.clear();
                setIsLoadingProject(false);
            } catch (e) {
                console.error('Error loading project:', e);
                setIsLoadingProject(false);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [project]);

    // Load unit form data on unit change
    useEffect(() => {
        if (currentUnit) {
            const saved = unitData[currentUnit];
            if (saved) {
                const normalized = normalizeUnitFormBySchema(saved, currentUnit);
                setUnitForm(normalized);
                recomputePreviewsFrom(normalized);
                if (fileInputRef.current) fileInputRef.current.value = '';
            } else {
                const empty = buildInitialUnitForm(currentUnit);
                setUnitForm(empty);
                setPreviews([]);
                if (fileInputRef.current) fileInputRef.current.value = '';
            }
        }
    }, [currentUnit, isV2Project, unitTypeAssignments, typeSchemas]);

    // Save unit form data
    useEffect(() => {
        if (currentUnit) setUnitData(prev => ({ ...prev, [currentUnit]: unitForm }));
    }, [unitForm, currentUnit]);

    // Field image click
    const handleFieldClick = field => {
        const imgs = fieldImages[field] || [];
        if (imgs.length) {
            setFieldSlides(imgs);
            setFieldSlideIndex(0);
        }
    };
    const closeFieldSlideshow = () => setFieldSlides([]);
    const nextFieldSlide = () => setFieldSlideIndex(i => (i + 1) % fieldSlides.length);
    const prevFieldSlide = () => setFieldSlideIndex(i => (i + fieldSlides.length - 1) % fieldSlides.length);

    // Checkbox change
    const handleCheckboxChange = (field, idx, checked) => {
        const isLocked = Boolean(lockedUnitData[currentUnit]?.[field]?.[idx]);
        if (isLocked) return;
        setUnitForm(u => {
            const arr = [...u.checkboxes[field]];
            arr[idx] = checked;
            return { ...u, checkboxes: { ...u.checkboxes, [field]: arr } };
        });
        setModifiedUnits(mu => ({ ...mu, [currentUnit]: true }));
    };

    // Photo handlers
    const handlePhotoChange = e => {
        const files = Array.from(e.target.files);
        setSelectedPhotos(Array.from(e.target.files));
        setUnitForm(u => {
            const next = { ...u, sitePhotos: [...u.sitePhotos, ...files] };
            recomputePreviewsFrom(next);
            return next;
        });
        setModifiedUnits(mu => ({ ...mu, [currentUnit]: true }));
        e.target.value = '';
    };
    const removePhoto = i => {
        setUnitForm(u => {
            const existingCount = (u.existingPhotoUrls || []).length;
            if (i < existingCount) {
                const nextExisting = u.existingPhotoUrls.filter((_, idx) => idx !== i);
                const next = { ...u, existingPhotoUrls: nextExisting };
                recomputePreviewsFrom(next);
                return next;
            } else {
                const fileIndex = i - existingCount;
                const nextFiles = u.sitePhotos.filter((_, idx) => idx !== fileIndex);
                const next = { ...u, sitePhotos: nextFiles };
                recomputePreviewsFrom(next);
                return next;
            }
        });
    };

    const updateDynamicFieldValue = (fieldKey, value) => {
        setUnitForm((prev) => ({
            ...prev,
            fieldValues: {
                ...(prev.fieldValues || {}),
                [fieldKey]: value
            }
        }));
        if (currentUnit) {
            setModifiedUnits((prev) => ({ ...prev, [currentUnit]: true }));
        }
    };

    // After successful submit, clear selected new photos and previews to avoid re-sending old ones
    useEffect(() => {
        if (result) {
            setUnitData({});
            setUnitForm(buildInitialUnitForm(currentUnit));
            setPreviews([]);
            if (fileInputRef.current) fileInputRef.current.value = '';
        }
    }, [result]);

    // Signature handlers
    const clearSignature = () => {
        sigPadRef.current.clear();
        setUnitForm(u => ({ ...u, signatureDataURL: '' }));
    };
    const saveSignature = () => {
        if (sigPadRef.current && !sigPadRef.current.isEmpty()) {
            // Use full canvas toDataURL instead of trimmed to avoid trim-canvas issues
            const dataURL = sigPadRef.current.getCanvas().toDataURL();
            setUnitForm(u => ({ ...u, signatureDataURL: dataURL }));
            return true;
        }
        return false;
    };


    // Submit
    const handleSubmit = async e => {
        e.preventDefault();

        // 1️⃣ Validate signature
        if (!sigPadRef.current || sigPadRef.current.isEmpty()) {
            return alert("Please sign before submitting.");
        }

        setIsSubmitting(true);

        try {
            // 2️⃣ Grab signature as DataURL
            const signatureDataURL = sigPadRef.current
                .getCanvas()
                .toDataURL("image/png");

            // 3️⃣ Helper: turn File → DataURL
            const fileToDataURL = file =>
                new Promise((resolve, reject) => {
                    const r = new FileReader();
                    r.onload    = () => resolve(r.result);
                    r.onerror   = reject;
                    r.readAsDataURL(file);
                });

            // 4️⃣ Build units object for ALL modified units only
            const unitsPayload = {};
            for (let [unitName, data] of Object.entries(unitData)) {
                if (!modifiedUnits[unitName]) continue;
                const deltaCheckboxes = {};
                let anyNewCheck = false;
                const unitFields = Object.keys(getCheckboxCountsForUnit(unitName));
                for (let field of unitFields) {
                    const base = lockedUnitData[unitName]?.[field] || [];
                    const cur = data.checkboxes[field] || [];
                    const delta = cur.map((v, i) => base[i] ? false : v);
                    if (delta.some(Boolean)) anyNewCheck = true;
                    deltaCheckboxes[field] = delta;
                }
                const photos = await Promise.all((data.sitePhotos || []).map(file => fileToDataURL(file)));
                const hasFieldValues = Object.values(data.fieldValues || {}).some((value) => {
                    if (value === null || value === undefined) return false;
                    if (typeof value === 'string') return value.trim().length > 0;
                    if (Array.isArray(value)) return value.length > 0;
                    if (typeof value === 'object') return Object.keys(value).length > 0;
                    return true;
                });
                if (!anyNewCheck && photos.length === 0 && !hasFieldValues) continue; // skip units with no changes

                unitsPayload[unitName] = {
                    notes:      data.notes,
                    checkboxes: deltaCheckboxes,
                    sitePhotos: photos,
                    existingPhotoUrls: Array.isArray(data.existingPhotoUrls) ? data.existingPhotoUrls : [],
                    fieldValues: data.fieldValues || {}
                };
            }
            if (Object.keys(unitsPayload).length === 0) {
                setIsSubmitting(false);
                return alert('No changes to submit. Please add photos or check items.');
            }

            // 5️⃣ Gather globals + signature
            const payload = {
                project,
                stackerType,
                date,
                manpower,
                manpowerHours,
                summary,
                notesAndIssues,
                reportSenderName,
                numberOfEmployees,
                signature: signatureDataURL,   // <— DataURL too
                units:     unitsPayload,
                isV2Project,
                unitTypeAssignments
            };
            
            console.log('🔍 Form Debug - Submitting payload:', {
                manpower,
                manpowerHours,
                manpowerHoursType: typeof manpowerHours,
                manpowerHoursValue: JSON.stringify(manpowerHours)
            });


            // 6️⃣ Send as JSON
            const res = await fetch(buildServerUrl('/webhook'), {
                method:  "POST",
                headers: { "Content-Type": "application/json" },
                body:    JSON.stringify(payload)
            });
            if (!res.ok) {
                const err = await res.text();
                throw new Error(err || res.status);
            }
            const json = await res.json();
            console.log("✅ Server responded:", json);
            setResult(json);
            // Clear submitted units' transient state after successful submit
            setUnitData(prev => {
                const next = { ...prev };
                for (const unitName of Object.keys(unitsPayload)) {
                    next[unitName] = { ...next[unitName], sitePhotos: [] };
                }
                return next;
            });
            setModifiedUnits(mu => {
                const next = { ...mu };
                for (const unitName of Object.keys(unitsPayload)) delete next[unitName];
                return next;
            });
            if (unitData[currentUnit]) {
                setUnitForm(unitData[currentUnit]);
                recomputePreviewsFrom(unitData[currentUnit]);
            } else {
                setUnitForm(buildInitialUnitForm(currentUnit));
                setPreviews([]);
            }
            if (fileInputRef.current) fileInputRef.current.value = '';
            
            setIsSubmitting(false);
            
            // Show success alert and refresh page
            alert("Report sent successfully!");
            window.location.reload();
        } catch (err) {
            console.error("❌ Submit failed:", err);
            setIsSubmitting(false);
            alert("Submit failed: " + err.message);
        }
    };


return (
        <div className="container py-4">
            <div className="mb-4">
                <img
                    src={MainImage}
                    alt="Banner"
                    style={{ width: '100%', cursor: 'pointer' }}
                    onClick={() => setPreviewBigOpen(true)}
                />
            </div>
            <h1 className="text-center mb-4">Daily Progress Form</h1>
            <form onSubmit={handleSubmit}>
                {/* Global fields */}
                <div className="row g-3 mb-4">
                    <div className="col-12 col-md-6">
                        <label className="form-label">Project *</label>
                        <select 
                            className="form-select" 
                            value={project} 
                            onChange={e => setProject(e.target.value)} 
                            disabled={isLoadingProject}
                            required
                        >
                            <option value="">Select project</option>
                            {projects.map(p => <option key={p}>{p}</option>)}
                        </select>
                        {isLoadingProject && project && (
                            <small className="text-muted d-block mt-1">
                                <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                Loading project data...
                            </small>
                        )}
                    </div>
                    <div className="col-12 col-md-6">
                        <label className="form-label">Stacker Type *</label>
                        {isV2Project ? (
                            <>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={
                                        (currentUnit && unitTypeAssignments?.[currentUnit]?.typeName)
                                        || 'Select a unit to see its stacker type'
                                    }
                                    disabled
                                    readOnly
                                />
                                <small className="text-muted d-block mt-1">
                                    Mixed-type project enabled. Unit type assignments are controlled in Admin Stackers setup.
                                </small>
                            </>
                        ) : (
                            <select
                                className="form-select"
                                value={stackerType}
                                onChange={e => setStackerType(e.target.value)}
                                disabled={isLoadingProject}
                                required
                            >
                                <option value="">Select type</option>
                                {stackerTypes.map(t => <option key={t}>{t}</option>)}
                            </select>
                        )}
                    </div>
                    <div className="col-12 col-md-4">
                        <label className="form-label">Date *</label>
                        <input type="date" className="form-control" value={date} onChange={e => setDate(e.target.value)} required />
                    </div>
                    <div className="col-12 col-md-4">
                        <label className="form-label">Manpower *</label>
                        <input type="text" className="form-control" value={manpower} onChange={e => setManpower(e.target.value)} placeholder="First name + last initial" required />
                    </div>
                    <div className="col-12 col-md-4">
                        <label className="form-label">Hours Worked *</label>
                        <input type="number" className="form-control" value={manpowerHours} onChange={e => setManpowerHours(e.target.value)} placeholder="e.g., 8" min="0" step="0.5" required />
                    </div>
                    <div className="col-12 col-md-4">
                        <label className="form-label">Progress Summary *</label>
                        <input type="text" className="form-control" value={summary} onChange={e => setSummary(e.target.value)} required />
                    </div>
                    <div className="col-12 col-md-4">
                        <label className="form-label">Report Sender Name *</label>
                        <input 
                            type="text" 
                            className="form-control" 
                            value={reportSenderName} 
                            onChange={e => setReportSenderName(e.target.value)} 
                            placeholder="Enter sender name"
                            required 
                        />
                    </div>
                    <div className="col-12 col-md-4">
                        <label className="form-label">Number of Employees *</label>
                        <input 
                            type="number" 
                            className="form-control" 
                            value={numberOfEmployees} 
                            onChange={e => setNumberOfEmployees(e.target.value)} 
                            placeholder="Enter number of employees"
                            min="1"
                            required 
                        />
                    </div>
                    <div className="col-12">
                        <label className="form-label">Notes and Issues for Management Attention *</label>
                        <textarea 
                            className="form-control" 
                            rows={4} 
                            value={notesAndIssues} 
                            onChange={e => setNotesAndIssues(e.target.value)} 
                            placeholder="Enter detailed notes and issues that require management attention..."
                            required 
                        />
                    </div>
                    <div className="col-12">
                        <label className="form-label">Notes & Issues *</label>
                        <textarea
                            className="form-control"
                            rows={2}
                            value={unitForm.notes}
                            onChange={e => {
                                setUnitForm({ ...unitForm, notes: e.target.value });
                                if (currentUnit) setModifiedUnits(prev => ({ ...prev, [currentUnit]: true }));
                            }}
                            required
                        />
                    </div>
                </div>

                {/* Stacker Unit */}
                <div className="mb-4">
                    <label className="form-label">Stacker Unit *</label>
                    <select className="form-select" value={currentUnit} onChange={e => setCurrentUnit(e.target.value)} required>
                        <option value="">Select unit</option>
                        {unitsList.map(u => <option key={u}>{u}</option>)}
                    </select>
                </div>

                {/* Quantity Completed */}
                <h5 className="mb-3">Quantity Completed Today *</h5>
                <div className="row">
                    {quantityFields.map(f => (
                        <div className="col-12 col-md-4 mb-3" key={f}>
                            <label
                                className={`form-label ${fieldImages[f]?.length ? 'text-primary' : ''}`}
                                style={{ cursor: fieldImages[f] ? 'pointer' : 'default' }}
                                onClick={() => handleFieldClick(f)}
                            >
                                {f}
                            </label>
                            <div className="d-flex flex-wrap">
                                {unitForm.checkboxes[f].map((checked, i) => {
                                    const isLocked = Boolean(lockedUnitData[currentUnit]?.[f]?.[i]);
                                    return (
                                    <div className="form-check me-2" key={i}>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={checked}
                                            disabled={isLocked || (!isV2Project && f === 'Crossbeams' && stackerType !== 'APS FS2000')}
                                            style={isLocked ? { accentColor: '#6c757d' } : undefined}
                                            onChange={e => handleCheckboxChange(f, i, e.target.checked)}
                                        />
                                    </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>

                {false && isV2Project && currentUnitSchema && Array.isArray(currentUnitSchema.fields) && currentUnitSchema.fields.length > 0 && (
                    <>
                        <h5 className="mb-3 mt-4">Type-Specific Fields ({currentUnitSchema.typeName || 'Current Type'})</h5>
                        <div className="row">
                            {currentUnitSchema.fields.map((field) => {
                                const fieldKey = field.fieldKey;
                                const value = unitForm.fieldValues?.[fieldKey] ?? '';
                                const configOptions = Array.isArray(field.config?.options) ? field.config.options : [];
                                return (
                                    <div className="col-12 col-md-6 mb-3" key={fieldKey}>
                                        <label className="form-label">
                                            {field.label || fieldKey}
                                            {field.required ? ' *' : ''}
                                        </label>
                                        {field.inputKind === 'number' && (
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={value}
                                                onChange={(e) => updateDynamicFieldValue(fieldKey, e.target.value)}
                                            />
                                        )}
                                        {field.inputKind === 'select' && (
                                            <select
                                                className="form-select"
                                                value={value}
                                                onChange={(e) => updateDynamicFieldValue(fieldKey, e.target.value)}
                                            >
                                                <option value="">Select...</option>
                                                {configOptions.map((opt) => {
                                                    const val = typeof opt === 'string' ? opt : opt?.value;
                                                    const label = typeof opt === 'string' ? opt : (opt?.label || opt?.value);
                                                    return <option key={val} value={val}>{label}</option>;
                                                })}
                                            </select>
                                        )}
                                        {field.inputKind === 'checkbox_group' && (
                                            <div className="d-flex flex-wrap gap-2">
                                                {configOptions.map((opt) => {
                                                    const val = typeof opt === 'string' ? opt : opt?.value;
                                                    const label = typeof opt === 'string' ? opt : (opt?.label || opt?.value);
                                                    const selectedValues = Array.isArray(value) ? value : [];
                                                    const checked = selectedValues.includes(val);
                                                    return (
                                                        <div className="form-check me-2" key={val}>
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                checked={checked}
                                                                onChange={(e) => {
                                                                    const current = Array.isArray(unitForm.fieldValues?.[fieldKey]) ? unitForm.fieldValues[fieldKey] : [];
                                                                    const next = e.target.checked
                                                                        ? [...current, val]
                                                                        : current.filter((v) => v !== val);
                                                                    updateDynamicFieldValue(fieldKey, next);
                                                                }}
                                                            />
                                                            <label className="form-check-label">{label}</label>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                        {(field.inputKind === 'text' || field.inputKind === 'photo_group' || !['number', 'select', 'checkbox_group'].includes(field.inputKind)) && (
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={value}
                                                onChange={(e) => updateDynamicFieldValue(fieldKey, e.target.value)}
                                                placeholder={field.inputKind === 'photo_group' ? 'Photo notes / metadata' : ''}
                                            />
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </>
                )}

                {/* Site Photos */}
                <div className="mb-4">
                    <label className="form-label">Site Photos *</label>
                    <input type="file" className="form-control" multiple accept="image/*" onChange={handlePhotoChange} ref={fileInputRef} required={previews.length===0} />
                    <div className="d-flex flex-wrap mt-2">
                        {previews.map((src,i) => (
                            <div key={i} style={{position:'relative',margin:8}}>
                                <img src={src} style={{width:100,height:100,objectFit:'cover',cursor:'pointer'}} onClick={()=>setSelectedImage(src)} />
                                <button type="button" onClick={()=>removePhoto(i)} style={{position:'absolute',top:4,right:4,background:'rgba(0,0,0,0.5)',color:'white',border:'none',borderRadius:'50%',padding:'2px 6px',cursor:'pointer'}}>×</button>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Signature */}
                <div className="mb-4">
                    <label className="form-label">Signature *</label><br/>
                    <SignatureCanvas penColor="black" ref={sigPadRef} canvasProps={{width:'500',height:'200',className:'border',style:{backgroundColor:'white'}}} /><br/>
                    <button type="button" className="btn btn-secondary mt-2" onClick={clearSignature}>Clear Signature</button>
                </div>

                {/* Submit */}
                <button 
                    type="submit" 
                    className="btn btn-primary w-100" 
                    disabled={isSubmitting || isLoadingProject}
                >
                    {isSubmitting ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Submitting...
                        </>
                    ) : (
                        'Submit'
                    )}
                </button>
            </form>

            {/* Loading overlay for project loading */}
            {isLoadingProject && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    background: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 3000
                }}>
                    <div className="text-center text-white">
                        <div className="spinner-border mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <div>Loading project data...</div>
                    </div>
                </div>
            )}

            {/* Loading overlay for submission */}
            {isSubmitting && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    background: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 3000
                }}>
                    <div className="text-center text-white">
                        <div className="spinner-border mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <div>Submitting report...</div>
                    </div>
                </div>
            )}

            {/* Field Slideshow Modal */}
            {fieldSlides.length > 0 && (
                <div style={{position:'fixed',top:0,left:0,width:'100vw',height:'100vh',background:'rgba(0,0,0,0.8)',display:'flex',justifyContent:'center',alignItems:'center',zIndex:2000}}>
                    <button onClick={closeFieldSlideshow} style={{position:'absolute',top:16,right:16,background:'rgba(255,255,255,0.7)',border:'none',borderRadius:'50%',width:32,height:32,fontSize:24,cursor:'pointer'}}>×</button>
                    <button onClick={prevFieldSlide} className="btn btn-light" style={{position:'absolute',left:16}}>‹</button>
                    <div className="text-white position-absolute top-0 start-50 translate-middle-x mt-3">{fieldSlideIndex+1} / {fieldSlides.length}</div>
                    <img src={fieldSlides[fieldSlideIndex]} alt={`slide-${fieldSlideIndex}`} style={{maxWidth:'80%',maxHeight:'80%'}} />
                    <button onClick={nextFieldSlide} className="btn btn-light" style={{position:'absolute',right:16}}>›</button>
                </div>
            )}

            {/* Photo Modal */}
            {selectedImage && (
                <div style={{position:'fixed',top:0,left:0,width:'100vw',height:'100vh',background:'rgba(0,0,0,0.8)',display:'flex',justifyContent:'center',alignItems:'center',zIndex:2000}}>
                    <button onClick={()=>setSelectedImage(null)} style={{position:'absolute',top:16,right:16,background:'rgba(255,255,255,0.7)',border:'none',borderRadius:'50%',width:32,height:32,fontSize:24,cursor:'pointer'}}>×</button>
                    <img src={selectedImage} alt="full" style={{maxWidth:'90%',maxHeight:'90%'}} />
                </div>
            )}
            {/* Big Banner Modal */}
            {previewBigOpen && (
                <div style={{position:'fixed',top:0,left:0,width:'100vw',height:'100vh',background:'rgba(0,0,0,0.8)',display:'flex',justifyContent:'center',alignItems:'center',zIndex:2000}}>
                    <button onClick={() => { setPreviewBigOpen(false); setBigZoom(1); }} style={{position:'absolute',top:16,right:16,background:'rgba(255,255,255,0.7)',border:'none',borderRadius:'50%',width:32,height:32,fontSize:24,cursor:'pointer'}}>×</button>
                    <div className="text-white position-absolute top-0 start-50 translate-middle-x mt-3">Zoom: {Math.round(bigZoom * 100)}%</div>
                    <img onWheel={handleWheelBig} src={MainImage} alt="banner-full" style={{transform:`scale(${bigZoom})`,cursor:'move',maxWidth:'80%',maxHeight:'80%'}} />
                </div>
            )}
        </div>
    );
}

